import React, { useState } from "react";
import { FiSend, FiMail, FiMapPin, FiClock } from "react-icons/fi";
import Frame from "../chrome/Frame";
import Meta from "../chrome/Meta";
import brand from "../content/brand";

const Contact = () => {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", company: "", email: "", area: "Brand strategy", message: "" });
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = (e) => { e.preventDefault(); setSent(true); };

  return (
    <Frame>
      <Meta title="Contact" description={`Reach ${brand.name} — based in ${brand.hq.city}, ${brand.hq.country}.`} />
      <section className="svc-hero">
        <div className="shell">
          <div className="crumb"><a href="/">Home</a><span className="sep">/</span>Contact</div>
          <span className="eyebrow">Start a brief</span>
          <h1>Send a brand on the move.</h1>
          <p className="lede">
            Tell us what you want to change. We respond within one business day with a candid view — even if our take
            is that the timing or scope is not right yet.
          </p>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="dispatch">
            <div className="dispatch-info">
              <span className="eyebrow">Direct channels</span>
              <h2 style={{ fontSize: "1.9rem" }}>The fastest paths in.</h2>
              <p style={{ color: "#64748b", marginBottom: "2rem" }}>
                For most enquiries the form on the right is the quickest route. The channels below also land directly
                with the senior team.
              </p>
              <div className="block">
                <div className="lbl"><FiMail style={{ marginRight: 6 }} /> E-MAIL</div>
                <a className="val" href={`mailto:${brand.contact.email}`}>{brand.contact.email}</a>
              </div>
              <div className="block">
                <div className="lbl"><FiMapPin style={{ marginRight: 6 }} /> OFFICE</div>
                <div className="val" style={{ lineHeight: 1.45 }}>
                  {brand.hq.address.line1}<br />
                  {brand.hq.address.line2}
                </div>
              </div>
              <div className="block">
                <div className="lbl"><FiClock style={{ marginRight: 6 }} /> HOURS</div>
                <div className="val">{brand.contact.hours}</div>
              </div>
            </div>

            <div className="dispatch-form">
              {sent ? (
                <div style={{ textAlign: "center", padding: "2rem 0" }}>
                  <h3>Brief received.</h3>
                  <p style={{ color: "#64748b" }}>A senior team member will reply within one business day.</p>
                </div>
              ) : (
                <form onSubmit={submit}>
                  <h3>Send a brief.</h3>
                  <p style={{ color: "#64748b", fontSize: ".95rem", margin: "0 0 1.5rem" }}>
                    A few honest lines is enough. We'll ask the right follow-up questions.
                  </p>
                  <div className="field-row">
                    <div className="field">
                      <label>Name</label>
                      <input required value={form.name} onChange={update("name")} placeholder="Jane Doe" />
                    </div>
                    <div className="field">
                      <label>Company</label>
                      <input value={form.company} onChange={update("company")} placeholder="Brand or company" />
                    </div>
                  </div>
                  <div className="field">
                    <label>Email</label>
                    <input required type="email" value={form.email} onChange={update("email")} placeholder="you@brand.com" />
                  </div>
                  <div className="field">
                    <label>Capability of interest</label>
                    <select value={form.area} onChange={update("area")}>
                      <option>Brand strategy</option><option>Performance media</option>
                      <option>Content & SEO</option><option>Social & Creator</option>
                      <option>Design & Visual identity</option><option>Campaign creative</option>
                      <option>Growth experiments</option><option>Analytics</option>
                      <option>PR & Communications</option><option>Other / not sure</option>
                    </select>
                  </div>
                  <div className="field">
                    <label>Brief</label>
                    <textarea required value={form.message} onChange={update("message")}
                      placeholder="What are you trying to change — and any constraints we should know about?" />
                  </div>
                  <button type="submit" className="btn btn--cobalt">Send brief <FiSend /></button>
                  <div className="note">
                    By submitting you agree {brand.name} may contact you about your enquiry. We do not share or sell submissions.
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </Frame>
  );
};

export default Contact;
